import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';

@Component({
    selector: 'view-dialog',
    templateUrl: 'view-dialog.html',
    styleUrls: ['./view-dialog.component.css']
})

export class ViewSurveyservice {
    status: any;
    adminIDsArray = [];
    updatedBy: any;
    owner: any;
    sharedWith: any;
    showLoader: boolean;
    email : any;
    sharedwithnames:string = "";
    lengthofsharedwith:any;
    constructor(
        public dialogRef: MatDialogRef<ViewSurveyservice>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.sharedWith = this.data.sharedWith
        if(this.data.sharedWith)
        {
        this.adminIDsArray = this.adminIDsArray.concat(this.data.sharedWith);
        }
        this.sharedWith = [];
        this.showLoader = true;
        this.owner ='NA';
        this.updatedBy = 'NA';
        if(this.adminIDsArray.length != 0 )
        {
        this.restApiService.getAdminNames(this.adminIDsArray).subscribe(result => {
            if (result.success) {
                this.lengthofsharedwith=result.result.length-1;
                for (let i in result.result) {
                    this.sharedwithnames=this.sharedwithnames+result.result[i].userName;
                    if(i != this.lengthofsharedwith)
                    {
                    this.sharedwithnames = this.sharedwithnames +',';
                    }
                    }
                    this.showLoader = false;
                }
            });
        }
    else
    {
        this.sharedwithnames="None";
        this.showLoader = false;
    }

        if (this.data.status == 'p') {
            this.status = 'Published';
        }
        else if (this.data.status == 'd'||this.data.status == 'e') {
            this.status = 'Draft';
        }
    }

    onClose() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/viewInfoservice.ts